// extracted by mini-css-extract-plugin
export var tier = "tier-details-module--tier--Pj8V5";
export var header = "tier-details-module--header---IHde";
export var price = "tier-details-module--price--PoZUk";
export var description = "tier-details-module--description--QwkNP";
export var compatibility = "tier-details-module--compatibility--U7Be7";
export var parts = "tier-details-module--parts--zD7sC";